module.exports = __webpack_public_path__ + "img/ad.c9e8d4d.svg";